import React, { useEffect, createElement } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (link) {
      link.href = 'https://cdn.magicpatterns.com/uploads/u58yyudAVGYZM45T7aPn3Z/PP_Logo_Lime.svg';
    } else {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.type = 'image/svg+xml';
      newLink.href = 'https://cdn.magicpatterns.com/uploads/u58yyudAVGYZM45T7aPn3Z/PP_Logo_Lime.svg';
      document.head.appendChild(newLink);
    }
  }, []);
  return <div className="min-h-screen bg-bg text-text selection:bg-lime selection:text-bg" data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/impressum" element={<Impressum data-id="element-5" />} data-id="element-4" />
        <Route path="/datenschutz" element={<Datenschutz data-id="element-7" />} data-id="element-6" />
      </Routes>
      <Footer data-id="element-8" />
    </div>;
}